
<!-- Conteneur principal du composant, avec classes dynamiques issues du content -->
<div v-if="newRegFlow" class="modal-container" :class="jel_getClassObject(content)">
  <div class="modal-btn-wrapper">
    <!-- Bouton déclencheur de la modale, affiché seulement si un libellé est fourni -->
    <button
      v-if="content.libBtn"
      type="button"
      class="modal-trigger-btn btn w-xs-auto w-md-auto hauteur px-4 my-2 btn-primaire"
      @click="isModalOpen = true"
    >
      <span>{{ content.libBtn }}</span>
    </button>
  </div>

  <!-- Overlay de la modale — un clic en dehors de la boîte ferme la modale -->
  <div v-if="isModalOpen" class="modal-overlay" @click.self="closeModal">
    <div
      class="modal-create-account"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <!-- Bouton de fermeture (croix) -->
      <button type="button" class="modal-close" aria-label="Fermer" @click="closeModal">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M4 20L20 4" stroke="black" stroke-width="2" stroke-linecap="round" />
          <path d="M20 20L4 4" stroke="black" stroke-width="2" stroke-linecap="round" />
        </svg>
      </button>

      <!-- Partie supérieure : titre + texte descriptif -->
      <div class="mca-top">
        <!-- id ajouté pour le aria-labelledby sur le dialog -->
        <h3 id="modal-title">{{ content.modalTitre }}</h3>
        <!-- v-html utilisé intentionnellement pour du contenu riche (HTML depuis le CMS) -->
        <div v-if="modalText" class="mca-text" v-html="modalText"></div>
      </div>

      <!-- Partie inférieure : bouton d'inscription -->
      <div class="mca-bottom">
        <button
          type="button"
          class="modal-auth-btn btn hauteur px-4 my-2"
          :disabled="isLoading"
          @click="onSignup"
        >
          <!-- Indicateur de chargement pendant l'appel Auth0 -->
          <span>{{ isLoading ? '...' : content.modalLibBtn }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
